__turbopack_context__.v({
  "articlesTable": "articles-module-scss-module__9C_YSa__articlesTable",
  "articlesTopBarWrapper": "articles-module-scss-module__9C_YSa__articlesTopBarWrapper",
  "controlsFlex": "articles-module-scss-module__9C_YSa__controlsFlex",
  "expandCollapseWrapper": "articles-module-scss-module__9C_YSa__expandCollapseWrapper",
  "expandedDescription": "articles-module-scss-module__9C_YSa__expandedDescription",
  "expandedRestrictedSections": "articles-module-scss-module__9C_YSa__expandedRestrictedSections",
  "headlineCell": "articles-module-scss-module__9C_YSa__headlineCell",
  "mobileFullWidth": "articles-module-scss-module__9C_YSa__mobileFullWidth",
  "searchInputField": "articles-module-scss-module__9C_YSa__searchInputField",
  "tabSelect": "articles-module-scss-module__9C_YSa__tabSelect",
});
